<template>
    <div class="numberDiv">
        <ilabel v-if="label" :m="isMobile?'':undefined" :label="label" :required="required"/>
        <div>
            <btn :m="m" class="numberL"  @press="minus" label="-"/>
            <input class="numberInput" type="text" @change="change" :value="value" />
            <btn :m="m"  class="numberR" @press="plus" label="+"/>
        </div>
    </div>
</template>

<script>
    export default {
        name: "number-input",
        computed:{
            isMobile(){
                return this.m === "";
            }
        },
        props:{
            "m":String,
            "label":String,
            "value":Number,
            "required":{type:Boolean,default:false},
            "step":{
                type:Number,
                default:1
            }
        },
        methods: {
            plus(){
                this.$emit('input', parseFloat((this.value+this.step).toFixed(2)));
            },
            minus(){
                this.$emit('input', parseFloat((this.value-this.step).toFixed(2)));
            },
            change(e){
                this.$emit('input', parseFloat((e.target.value).toFixed(2)));
            }
        }
    }
</script>

<style scoped>

    .numberDiv {
        display: block;
        text-align: center;
        overflow: hidden;
        margin-bottom:8px;
    }
    .numberInput{
        font-size: 22px;
        width: 70px;
        color:grey;
        border:1px solid lightgrey;
        text-align:center;
        margin-right: 0px;
        border-left: none;
        border-right: none;
        padding:6px;
        border-radius:0;
        -webkit-appearance: none;
    }
    .numberR{
        background-color: #fff;
        color: grey;
        width: 55px;
        font-size: 20px;
        padding:7px;
        border:1px solid lightgrey;
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
    }
    .numberR:active{
        background-color: lightgrey;
    }
    .numberL{
        background-color: #fff;
        color: grey;
        width: 55px;
        font-size: 20px;
        padding:7px;
        border: 1px solid lightgrey;
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;

    }
    .numberL:active{
        background-color: lightgrey;

    }
    .btn{
        display: inline-block;
        vertical-align: top;
        margin-right: -3px;
    }
    .btn:last-child{
        margin-left: -3px;

    }
</style>